import React from 'react';
import { FONT_BODY } from './theme';
import { Kicker, CtaButton } from './ui';
import { WhatsAppIcon, ArrowIcon } from './icons';

const ContactSection: React.FC<{ seen: boolean; onEnquiry: () => void }> = ({ seen, onEnquiry }) => (
  <section
    id="contact"
    style={{ scrollMarginTop: 74, padding: 'clamp(6px,1.4vw,14px) clamp(16px,4vw,30px) clamp(36px,4.5vw,60px)' }}
  >
    <div
      style={{
        maxWidth: 1180,
        margin: '0 auto',
        background: '#fff',
        border: '1px solid #E7EEF9',
        borderRadius: 18,
        boxShadow: '0 24px 50px -34px rgba(15,45,107,.3)',
        padding: 'clamp(18px,2.4vw,26px) clamp(18px,3vw,32px)',
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        gap: '16px 26px',
        opacity: seen ? 1 : 0,
        transform: seen ? 'none' : 'translateY(24px)',
        transition: 'opacity .7s ease,transform .7s cubic-bezier(.2,.7,.2,1)',
      }}
    >
      <span
        style={{
          width: 52,
          height: 52,
          borderRadius: 14,
          background: '#E7F8EF',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flex: 'none',
        }}
      >
        <WhatsAppIcon />
      </span>
      <div style={{ flex: '1 1 300px', minWidth: 0 }}>
        <Kicker>Direct enquiry</Kicker>
        <h2
          style={{
            font: `800 clamp(21px,2.4vw,26px)/1.2 ${FONT_BODY}`,
            letterSpacing: '-.03em',
            color: '#0F172A',
            margin: '8px 0 0',
          }}
        >
          Talk to Soomuch.AI
        </h2>
        <p
          style={{
            font: `400 14.5px/1.55 ${FONT_BODY}`,
            color: '#475569',
            margin: '6px 0 0',
            textWrap: 'pretty',
          }}
        >
          Want to speak with our team about your school? Send a quick enquiry and we&apos;ll reach out on WhatsApp.
        </p>
      </div>
      <CtaButton variant="dark" onClick={onEnquiry} style={{ flex: 'none' }}>
        Send an Enquiry
        <ArrowIcon size={15} />
      </CtaButton>
    </div>
  </section>
);

export default ContactSection;
